import styled from 'styled-components'

const LessonVideoStyled = styled.div`
  position: relative;
  background: black;
  padding-top: 56.25%;
  .video-observer {
    bottom: 100%;
    position: absolute;
    right: 0;
    left: 0;
    height: 1px;
  }
  .video-container {
    max-height: 80vh;
    /* aspect-ratio: 16 / 9; */
    margin: 0 auto;
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
  }
  .vimeo-container {
    padding-top: 0;
  }
  .video-fixed {
    .vimeo-container {
      padding-top: 56.25%;
    }
    position: fixed;
    bottom: 16px;
    right: 16px;
    width: 70%;
    top: unset;
    left: unset;
    z-index: 2;
    &:hover .video-fixed-controls{
      visibility: visible;
      opacity: 1;
    }
  }
  .video-fixed-controls {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    visibility: hidden;
    opacity: 0;
    box-sizing: border-box;
    height: 56px;
    z-index: 1;
    padding: 16px;
    font: var(--p2Bold);
    color: var(--neutral10);
    background: linear-gradient(0deg, rgba(4, 0, 30, 0) 0%, rgb(4 0 30 / 60%) 50%, rgb(4 0 30 / 50%) 100%);
    transition: 0.2s ease-in opacity;
    p {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      margin-right: 16px;
    }
    img {
      transform: rotateY(180deg);
    }
  }
  .video-fixed-number {
    color: var(--turquoise);
    margin-right: 4px;
  }
  @media(min-width: 1024px) {
    .video-observer {
      bottom: 50%;
      position: absolute;
      right: 0;
      left: 0;
      height: 1px;
    }
    .video-fixed {
      bottom: 32px;
      right: 24px;
      width: ${({ width }) => `calc(calc(${width}px * 0.3) - 24px)`};
    }
  }
  @media(min-width: 1366px) {
    aspect-ratio: unset;
    height: 80vh;
    padding-top: 0;
  }
`

export default LessonVideoStyled
